<template>
    <div class="pa-4">
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            :search="search">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Tabel Bantuan</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical />
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details />
                    <v-spacer />
                </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="viewTabelBantuan(item)">
                    mdi-eye
                </v-icon>
                <v-icon small class="mr-2" @click="editTabelBantuan(item)" v-if="$store.state.currentPagePriv.update">
                    mdi-pencil
                </v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">
                    Reset
                </v-btn>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    data: () => ({
        headers: [
            { text: 'Outlet', value: 'name' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],
        items:[],
        search: '',
    }),

    created() {
        this.initialize()
    },

    methods: {
        async initialize() {
            let response = await this.$store.dispatch('outlet/getObjs', { skip_access_filter: true })
            if (response.data.status == 'success') {
                this.items = response.data.data
            }
        }, 
        viewTabelBantuan(item) {
            this.$router.push(`/tabel-bantuan/view/${item.code}`);
        },
        editTabelBantuan(item) {
            this.$router.push(`/tabel-bantuan/${item.code}`);
        },
    }
}
</script>